import { render, staticRenderFns } from "./FullwidthContentImageParallaxSection.vue?vue&type=template&id=9dbde512&"
import script from "./FullwidthContentImageParallaxSection.vue?vue&type=script&lang=js&"
export * from "./FullwidthContentImageParallaxSection.vue?vue&type=script&lang=js&"
import style0 from "./FullwidthContentImageParallaxSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports